module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v1-1040.f2be3939.png";